// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel {
  position: relative;
  border-radius: var(--radius-lg);
  overflow: hidden;
  box-shadow: var(--shadow);
  background: var(--color-navy-600);
  outline: none;
}

.carousel:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 3px;
}

.carousel__viewport {
  position: relative;
  width: 100%;
  height: clamp(320px, 55vw, 520px);
  overflow: hidden;
  background: var(--color-navy-600);
}

.carousel__image {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  animation: carousel-fade-in 0.4s ease;
}

@keyframes carousel-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .carousel__image {
    animation: none;
  }
}

.carousel__control {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.75rem;
  height: 2.75rem;
  border-radius: var(--radius-pill);
  background: rgba(11, 27, 52, 0.55);
  color: var(--color-cream-200);
  backdrop-filter: blur(2px);
  transition:
    background var(--transition),
    transform var(--transition);
}

.carousel__control svg {
  width: 1.4rem;
  height: 1.4rem;
}

.carousel__control:hover {
  background: var(--interactive);
  color: var(--interactive-fg);
}

.carousel__control:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

.carousel__control--prev {
  left: 0.75rem;
}

.carousel__control--next {
  right: 0.75rem;
}

.carousel__counter {
  position: absolute;
  right: 0.75rem;
  bottom: 0.75rem;
  padding: 0.3rem 0.7rem;
  background: rgba(11, 27, 52, 0.55);
  color: var(--color-cream-200);
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  border-radius: var(--radius-pill);
  backdrop-filter: blur(2px);
}

@media (max-width: 560px) {
  .carousel__viewport {
    height: clamp(240px, 75vw, 360px);
  }

  .carousel__control {
    width: 2.25rem;
    height: 2.25rem;
  }

  .carousel__control svg {
    width: 1.1rem;
    height: 1.1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/Carousel/Carousel.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,yBAAyB;EACzB,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iCAAiC;EACjC,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,kCAAkC;EAClC,6BAA6B;EAC7B,0BAA0B;EAC1B;;+BAE6B;AAC/B;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,kCAAkC;EAClC,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE;IACE,iCAAiC;EACnC;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;AACF","sourcesContent":[".carousel {\n  position: relative;\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  box-shadow: var(--shadow);\n  background: var(--color-navy-600);\n  outline: none;\n}\n\n.carousel:focus-visible {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 3px;\n}\n\n.carousel__viewport {\n  position: relative;\n  width: 100%;\n  height: clamp(320px, 55vw, 520px);\n  overflow: hidden;\n  background: var(--color-navy-600);\n}\n\n.carousel__image {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  object-position: center;\n  animation: carousel-fade-in 0.4s ease;\n}\n\n@keyframes carousel-fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .carousel__image {\n    animation: none;\n  }\n}\n\n.carousel__control {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.75rem;\n  height: 2.75rem;\n  border-radius: var(--radius-pill);\n  background: rgba(11, 27, 52, 0.55);\n  color: var(--color-cream-200);\n  backdrop-filter: blur(2px);\n  transition:\n    background var(--transition),\n    transform var(--transition);\n}\n\n.carousel__control svg {\n  width: 1.4rem;\n  height: 1.4rem;\n}\n\n.carousel__control:hover {\n  background: var(--interactive);\n  color: var(--interactive-fg);\n}\n\n.carousel__control:focus-visible {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 2px;\n}\n\n.carousel__control--prev {\n  left: 0.75rem;\n}\n\n.carousel__control--next {\n  right: 0.75rem;\n}\n\n.carousel__counter {\n  position: absolute;\n  right: 0.75rem;\n  bottom: 0.75rem;\n  padding: 0.3rem 0.7rem;\n  background: rgba(11, 27, 52, 0.55);\n  color: var(--color-cream-200);\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  border-radius: var(--radius-pill);\n  backdrop-filter: blur(2px);\n}\n\n@media (max-width: 560px) {\n  .carousel__viewport {\n    height: clamp(240px, 75vw, 360px);\n  }\n\n  .carousel__control {\n    width: 2.25rem;\n    height: 2.25rem;\n  }\n\n  .carousel__control svg {\n    width: 1.1rem;\n    height: 1.1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
